import { legacyTimezoneAliases } from "../conts/legacyTimezones";

/**
 * Returns the browser's IANA timezone as-is, never swapped for one of the
 * dropdown's options, so a member in Phoenix or Boise books in their own zone.
 * Legacy names such as "US/Mountain" are mapped to their current name.
 */
export const getBrowserTimezone = (): string => {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (!timezone) {
      return "UTC";
    }
    const currentTimezone = legacyTimezoneAliases[timezone] ?? timezone;
    // PHP's list has no Etc/* zones, so a fixed-offset browser books in UTC.
    return currentTimezone.startsWith("Etc/") ? "UTC" : currentTimezone;
  } catch {
    return "UTC";
  }
};
